import { ButtonModule } from '@mhe/ngx-shared';
import { TooltipModule } from '@mhe/ngx-shared/tooltip';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { EpubControlsComponent } from './epub-controls.component';
import { TTSModule } from '@mhe/reader/components/text-to-speech';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    TranslateModule,
    TooltipModule,
    TTSModule,
    A11yModule,
  ],
  declarations: [EpubControlsComponent],
  exports: [EpubControlsComponent],
})
export class EpubControlsModule {}
